<template>
  <div class="w-full flex mx-auto lg:sticky lg:top-26 py-8 lg:px-4 xl:px-8 z-10" :class="[bgColor, btnData ? 'lg:justify-between' : 'lg:justify-center']">
    <div v-if="btnData" class="lg:w-4/12 xl:w-2/12" />
    <div class="w-full lg:w-auto ">
      <h1 class="text-center w-full font-semibold text-xl sm:text-2xl">
        {{ title }}
      </h1>
      <h2 v-if="subtitle" class="text-sm font-semibold text-primary-600 dark:text-primary-300">
        {{ subtitle }}
      </h2>
    </div>
    <div v-if="btnData" class="w-full lg:w-4/12 xl:w-2/12 px-2 sm:px-4 lg:px-0">
      <VButton
        :label="loading ? btnLoadingLabel : btnLabel"
        :size="screen.md ? 'xs' : 'md'"
        class="w-full lg:w-auto mx-auto lg:mr-0 mt-3 lg:mt-0"
        @click="loadData"
        uppercase
        :icon="!loading ? (btnData?.icon || 'fa-solid fa-rotate') : null"
        :icon-size="screen.md ? 'sm' : 'md'"
        icon-first
        :disabled="loading"
        :submitting-prepend="loading"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex"
import VButton from "@/components/Buttons/Button/VButton.vue"

export default {
  name: "PageTitle",
  components: {
    VButton
  },
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: false
    },
    bgColor: {
      type: String,
      default: "bg-gray-50 dark:bg-navy-1000"
    },
    btnData: {
      type: Object,
      required: false
    }
  },
  emits: [
    "btnDataLoaded"
  ],
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapState(["headers", "screen"]),
    btnLabel() {
      return this.btnData?.btnLabel || "Reload"
    },
    btnLoadingLabel() {
      return this.btnData?.btnLoadingLabel || "Loading..."
    }
  },
  methods: {
    ...mapMutations(["setPrompt"]),
    async loadData() {
      this.loading = true
      await this.btnData.endpoint(this.headers)
      .then((response) => {
        console.log(response)
        if (response.status === 200) {
          this.$emit('btnDataLoaded', response.data)
        } else {
          this.setPrompt(["Something went wrong.", "closePrompt", null, { header: "Error" }])
          console.error(response)
        }
      })
      .catch((error) => {
        console.error(error)
        this.setPrompt(["Something went wrong.", "closePrompt", null, { header: "Error" }])
      })
      this.loading = false
    }
  }
}
</script>